import { atom } from 'recoil';

/**
 * Only used for the UI. Metrics Event values do not depend on this atom.
 * Tracks accumulated time metrics for current session.
 */
export const timeMetricsUIAtom = atom({
  key: 'timeMetricsUIAtom',
  default: {
    activeTime: 0, // time spent actively using the tool (based on keyboard/ui/mouse inputs)
    inactiveTime: 0, // idle time without any key/mouse inputs
    elapsedClockTime: 0, // time elapsed since the scene finished loading
  },
});

export const annotationMetricsTallyAtom = atom({
  key: 'annotationMetricsTallyAtom',
  default: {} as { [key: string]: number },
});
